// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2V6hs","actionsCol":"EnrolledClinics_actionsCol__2E7f0"};